import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "SortArrow",
  "use": "SortArrow-usage",
  "viewBox": "0 0 14 20",
  "content": "<symbol viewBox=\"0 0 14 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"SortArrow\">\n  <path d=\"M14 13L12.59 11.59L8 16.17V0H6V16.17L1.41 11.58L0 13L7 20L14 13Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol